var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77778 0H1.11111C0.816426 0 0.533811 0.117063 0.325437 0.325437C0.117063 0.533811 0 0.816426 0 1.11111V7.77778C0 8.07246 0.117063 8.35508 0.325437 8.56345C0.533811 8.77183 0.816426 8.88889 1.11111 8.88889H7.77778C8.07246 8.88889 8.35508 8.77183 8.56345 8.56345C8.77183 8.35508 8.88889 8.07246 8.88889 7.77778V1.11111C8.88889 0.816426 8.77183 0.533811 8.56345 0.325437C8.35508 0.117063 8.07246 0 7.77778 0ZM18.8889 11.1111H12.2222C11.9275 11.1111 11.6449 11.2282 11.4365 11.4365C11.2282 11.6449 11.1111 11.9275 11.1111 12.2222V18.8889C11.1111 19.1836 11.2282 19.4662 11.4365 19.6746C11.6449 19.8829 11.9275 20 12.2222 20H18.8889C19.1836 20 19.4662 19.8829 19.6746 19.6746C19.8829 19.4662 20 19.1836 20 18.8889V12.2222C20 11.9275 19.8829 11.6449 19.6746 11.4365C19.4662 11.2282 19.1836 11.1111 18.8889 11.1111ZM15.5556 0C13.1044 0 11.1111 1.99333 11.1111 4.44444C11.1111 6.89556 13.1044 8.88889 15.5556 8.88889C18.0067 8.88889 20 6.89556 20 4.44444C20 1.99333 18.0067 0 15.5556 0ZM4.44444 11.1111C1.99333 11.1111 0 13.1044 0 15.5556C0 18.0067 1.99333 20 4.44444 20C6.89556 20 8.88889 18.0067 8.88889 15.5556C8.88889 13.1044 6.89556 11.1111 4.44444 11.1111Z",
    fill: "#F7F6F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.6509a05fe3bdf4d1b0766709206d0f13.svg";
export { ForwardRef as ReactComponent };